import store from "@/store/index.js";

export default [
  {
    path: "/userCenter",
    name: "userCenter",
    meta: { requiresAuth: true },
    component: () => import("@/views/UserCenter.vue"),
    children: [
      {
        path: "userInfo",
        name: "userInfo",
        meta: { requiresAuth: true },
        component: () => import("@/components/UserCenter/UserInfo.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchUserInfo");
          next();
        }
      },
      {
        path: "userPassword",
        name: "userPassword",
        meta: { requiresAuth: true },
        component: () => import("@/components/UserCenter/UserPassword.vue")
      }
    ]
  }
];
